@if (quote !== undefined) {
  <div class="td-wb-todays-change"
       [ngClass]="{ 'td-wb-green': hasDollarChangedUp(), 'td-wb-red': hasDollarChangedDown()}">
    <!-- hasDollarChanged => Show content if dollar value changed -->
    @if (hasDollarChanged()) {
      <!-- Arrow up or down based on dollar change -->
      <td-wb-icon-arrow [value]="hasDollarChangedUp()? 1: -1"
                        size="regular" />
      @if (isIssueTypeIndex()) {
        <span>
          <span [innerHTML]="quote.dollarChange | tdWbNumber: { color: true }"></span>
        </span>
      } @else {
        @if (!isLastPriceOneOrMore()) {
          <span
            [innerHTML]="quote.dollarChange | tdWbCurrency: { color: true, format: 'c4-2' }">
          </span>
        }
        @if (isLastPriceOneOrMore()) {
          <span
            [innerHTML]="quote.dollarChange | tdWbCurrency: { color: true, format: 'c2' }">
          </span>
        }
      }
      <span class="td-wb-todays-change__all-types">
        (<span [innerHTML]="quote.percentageChange | tdWbPercent: { prependSign: false, color: true }"></span>)
      </span>
    } @else {
      @if (!quote.sessionIsActive) {
        <span>
          <span [innerText]="null | tdWbNumber: { nullPlaceholder: '-' }"></span>
        </span>
      }
      @if (isIssueTypeIndex() && quote.sessionIsActive) {
        <span>
          <span [innerText]="0.00 | tdWbNumber : { format: 'n2'}"></span>
          (<span [innerText]="0.00 | tdWbPercent : { prependSign: false, format: 'n2' }"></span>)
        </span>
      }
      @if (!isIssueTypeIndex() && quote.sessionIsActive) {
        <span>
          <span [innerText]="0.00 | tdWbCurrency : { format: 'c2' }"></span>
          (<span [innerText]="0.00 | tdWbPercent: { prependSign: false }"></span>)
        </span>
      }
    }
  </div>
}
